import gsap from 'gsap';
import fitRect from 'fit-rect';
import { useCallback, useEffect, useState } from 'react';
import type { RefObject } from 'react';
import useWindowSize from '../../../../hooks/useWindowSize';

export default function useVideoResize(
  elementRef: RefObject<HTMLDivElement | null>,
  videoHolderRef: RefObject<HTMLDivElement | null>,
  objectFit: 'contain' | 'cover',
  isIframe: boolean,
): {
  updateVideoSize: () => void;
} {
  const windowSize = useWindowSize();
  const [containerWidth, setContainerWidth] = useState<number>();
  const [containerHeight, setContainerHeight] = useState<number>();

  const updateVideoSize = useCallback(() => {
    setContainerWidth(elementRef.current?.offsetWidth);
    setContainerHeight(elementRef.current?.offsetHeight);
  }, [elementRef]);

  useEffect(() => {
    updateVideoSize();
  }, [windowSize.width, windowSize.height, elementRef, updateVideoSize]);

  useEffect(() => {
    // We only have to 'cover' it with javascript if it's an iframe video (in this case vimeo_url),
    // otherwise the CSS object-fit: cover should do the trick.
    if (objectFit === 'cover' && isIframe) {
      const target = [0, 0, containerWidth, containerHeight];
      const newBounds = fitRect([0, 0, 16, 9], target, 'cover');
      gsap.set(videoHolderRef.current, {
        x: newBounds[0],
        y: newBounds[1],
        width: newBounds[2],
        height: newBounds[3],
      });
    }
  }, [objectFit, containerWidth, containerHeight, isIframe, videoHolderRef]);

  return {
    updateVideoSize,
  };
}
